export default {
    meta: {
        title: '历史列表',
        url: '/standardstore/tasklist',
        urlName: '标准版拓店-拓店任务'
    }
};
